import { Injectable } from '@angular/core';
import { InformationPlanet } from '../interfaces/information-planets';
import { Observable, map, of, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class InformationPlanetService {
    constructor (private http: HttpClient) { }

    processInformationPlanet (raceId: string, informationPlanet: InformationPlanet) {
        localStorage.setItem('iBody' + raceId + informationPlanet.bodyId, JSON.stringify(informationPlanet));
    };

    processInformationPlanets (raceId: string, informationPlanets: InformationPlanet[], fullRequest: boolean = false) {
        let groupedByStarSystem: { [key: string]: any; } = {};
        for (const informationPlanet of informationPlanets) {
            localStorage.setItem('iBody' + raceId + informationPlanet.bodyId, JSON.stringify(informationPlanet));
            let starSystemInfoPlanets = groupedByStarSystem[informationPlanet.starSystemId] || [];
            starSystemInfoPlanets.push(informationPlanet);
            groupedByStarSystem[informationPlanet.starSystemId] = starSystemInfoPlanets;
        }
        for (const starSystemId in groupedByStarSystem) {
            if (Object.prototype.hasOwnProperty.call(groupedByStarSystem, starSystemId)) {
                const informationPlanetsForStarSystem = groupedByStarSystem[starSystemId];
                localStorage.setItem('informationPlanets' + raceId + starSystemId, JSON.stringify(informationPlanetsForStarSystem));
            }
        }
        if (fullRequest) {
            localStorage.setItem('informationPlanets' + raceId, JSON.stringify(informationPlanets));
            localStorage.setItem('informationPlanetsFor' + raceId, 'processed');
        }
    };

    getInformationPlanetsForRaceId (raceId: string): Observable<InformationPlanet[]> {
        let cachedInformationPlanets = localStorage.getItem('informationPlanets' + raceId);
        if (cachedInformationPlanets) {
            let informationPlanets: InformationPlanet[] = JSON.parse(cachedInformationPlanets);
            return of<InformationPlanet[]>(informationPlanets);
        }
        return this.loadInformationPlanetsForRaceId(raceId);
    }

    loadInformationPlanetsForRaceId (raceId: string): Observable<InformationPlanet[]> {
        return this.http.get<InformationPlanet[]>('/api/informationPlanet/raceId/' + raceId)
            .pipe(
                // map(iss => JSON.parse(iss)),
                tap(informationPlanets => this.processInformationPlanets(raceId, informationPlanets, true)),
                map(informationPlanets => informationPlanets)
            );
    };

    getInformationPlanetsForRaceAndStarSystemIds (raceId: string, starSystemId: string | undefined): Observable<InformationPlanet[]> {
        if (!raceId || !starSystemId) {
            throw Error('raceId && starSystemId must have values!');
        }
        // let processedInformationPlanets = localStorage.getItem('informationPlanetsFor' + raceId);
        // if ('processed' != processedInformationPlanets) {
        //     this.loadInformationPlanetsForRaceId(raceId);
        // }

        // let informationPlanets = localStorage.getItem('informationPlanets' + raceId + starSystemId);
        // if (informationPlanets) {
        //     let tempInformationPlanets: InformationPlanet[] = JSON.parse(informationPlanets);
        //     return of<InformationPlanet[]>(tempInformationPlanets);
        // }

        // falling to here - data has not been requested/processed
        return this.http.get<InformationPlanet[]>('/api/informationPlanet/raceId/' + raceId + '/starSystemId/' + starSystemId).pipe(
            // tap(informationPlanets => this.processInformationPlanets(raceId, informationPlanets, false)),
            map(informationPlanets => informationPlanets)
        );
    }
};
